import Vue from "vue";
import Vuex from "vuex";

import { ModeldownStore } from "./modules/modeldown";
import { SearchStore } from "./modules/searchHistory";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    modeldown: ModeldownStore,
    search: SearchStore,
  },
});
